import {ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {mergeMap, map, catchError} from 'rxjs/operators';
import { IEpicDependency, IAppUser, IAppError } from '../../models';
import { IAppAction } from '../app-action';
import { sessionStateActions, loginError, loginSuccess } from './session-actions';
import { IAppState } from '../app-state';
import { sendToast, ToastType } from '../../helpers/sendToast';
import { fetchContactFamilyDetails, setContactOnLoginSuccess } from '../contact/contact-actions';
import { fetchCountries } from '../reference-data';
import { fetchHolidays } from '../holiday';
//import { fetchKeys } from '../fetch-api-keys';

export const loginEpic = (action$: ActionsObservable<IAppAction>, state$: StateObservable<IAppState>, {api, endPointKeys}:
    IEpicDependency): Observable<IAppAction> => action$.pipe(
        ofType(sessionStateActions.LOGIN),
        mergeMap(action => {
            var data = JSON.stringify(action.payload);
            return api.post(endPointKeys.api_contact, 'user/login', data).pipe(
                map(result => result.data),
                mergeMap((appUser : IAppUser) => {
                    localStorage.removeItem("timedOut");
                    // sendToast(`Welcome ${appUser.firstName}`, ToastType.Success);
                    return of(loginSuccess(appUser),
                            setContactOnLoginSuccess(appUser),
                            fetchCountries(),
                            fetchHolidays(appUser.id),
                            //fetchKeys(),
                            fetchContactFamilyDetails(appUser.id));
                }),
                catchError(error => {
                    const appError : IAppError = { error, message: "Failed to log in. Incorrect email address or password"};
                    sendToast(appError.message, ToastType.Error);
                    return of(loginError(appError));
                }))
        })
    )